import { StyleSheet } from 'react-native';
import { Dimensions, Platform } from 'react-native';
let deviceWidth = Dimensions.get('window').width;
if (Platform.OS === 'ios') {
  global.platform = 'ios';
} else if (Platform.OS === 'android') {
  global.platform = 'android';
} else if (Platform.OS === 'web') {
  global.platform = 'web';
} else {
  global.platform = 'web';
}

export default StyleSheet.create({
  outerContainer: { width: '100%', backgroundColor: 'white' },
  container: {
    //width: "75%",
    width: deviceWidth < 768 ? '90%' : '75%',
    justifyContent: 'center',
    display: 'flex',
    alignSelf: 'center',
    marginTop: 10,
    textAlign: 'left',
  },

  termsContainer_SMALL_MOBILE: {
    width: '90%',
  },
  termsContainer_MEDIUM_MOBILE: {
    width: '96%',
  },
  termsContainer_LARGE_MOBILE: {
    width: '90%',
  },
  termsContainer_SMALL_TABLET: {
    width: '86%',
  },
  termsContainer_MEDIUM_TABLET: {
    width: '80%',
  },
  termsContainer_LARGE_TABLET: {
    width: '80%',
  },
  termsContainer_LAPTOP: {
    width: '80%',
  },
  headerView: {
    height: 76,
    padding: 30,
    justifyContent: 'center',
  },
  heading: {
    fontSize: 28,
    textAlign: 'center',
    padding: 10,
    fontFamily: 'SFProText',
    fontWeight: '600',
    color: 'white',
  },
  headingText: {
    margin: 10,
    marginRight: 0,
    padding: 5,
    marginLeft: 0,
    fontSize: 16,
    textAlign: 'center',
    fontFamily: 'SFProText',
    color: '#273a4e',
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
  },
  paragraph:
    Platform.OS == 'web'
      ? {
          flexShrink: 1,
          paddingTop: 7,
          paddingBottom: 10,
          fontSize: 16,
          textAlign: 'left',
          fontFamily: 'SFProText',
          fontWeight: 'normal',
          color: '#273a4e',
        }
      : {
          width: '90%',
          flexShrink: 1,
          paddingTop: 7,
          paddingBottom: 10,
          fontSize: 16,
          textAlign: 'left',
          fontFamily: 'SFProText',
          fontWeight: 'normal',
          color: '#273a4e',
        },
  number: {
    paddingRight: 5,
    paddingTop: 7,
    paddingBottom: 10,
    fontSize: 16,
    textAlign: 'left',
    fontFamily: 'SFProText',
    fontWeight: 'normal',
    color: '#273a4e',
  },
  buttonView: {
    margin: 20,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  button: {
    height: 33,
    minWidth: 131,
    margin: 5,
    padding: 7,
    borderWidth: 1,
    borderColor: '#f14d31',
    backgroundColor: 'white',
    borderRadius: 17,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#f14d31',
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
  },
});
